<script>
import CategoryPromoCard from "./CategoryPromoCard.vue";
export default {
	name: 'CategoryPromos',
	components: { CategoryPromoCard },
	props: {		
		categoryPromos: Array,
	},
	data() {
		return {          
            categories: []
		};
	},
	mounted() {
        this.categories = this.$props.categoryPromos[0];
	}
};
</script>
